import Select, { components } from "react-select";
import React, { useEffect, useRef, useState } from "react";
import "./SearchSelect.css";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function SearchSelect(props) {
  const [focus, setFocus] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const containerRef = useRef(null);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        if (expanded) setExpanded(false);
        if (focus) {
          setFocus(false);
          allValidations();
        }
        if (selectRef.current) selectRef.current.blur();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [expanded, focus, props.value]);

  const alphanumericWithSpaceRegex = /^[a-zA-Z0-9\s]*$/;
  const alphanumericWithoutSpaceRegex = /^[a-zA-Z0-9]*$/;
  const AlphanNumeric = /^[A-Za-z0-9]*$/;
  const AplhaNumericWithSpecialChars = /^[A-Za-z\d\s-.()\\/|,!#_;@$%*&:[\]]*$/;
  const specialCharacterRegex = /[!@#$%^&*()]/;
  const AlphaNumericSpace = /^[A-Za-z0-9\s]*$/;

  let options = props?.option?.map((opt) => ({
    value: opt?.props?.value,
    label: opt?.props?.children
  }));
  const selectedOption = props.isMulti
    ? (Array.isArray(props.value) ? props.value.map(v => options.find(opt => opt.value === v)).filter(Boolean) : [])
    : options.find(opt => opt.value === props.value);

  props?.data?.map((item, index) => {
    let option = {};
    if (props.isPatternApplicable) {
      let fields = [{ propField: "valueField", optionField: "value" },
      { propField: "labelField", optionField: "label" }];
      let prevPattern = "";
      let prevValue = "";

      for (let fld of fields) {
        let fieldData = props[fld.propField];
        if (fieldData === prevPattern) {
          option[fld.optionField] = prevValue;
          break;
        }
        prevPattern = fieldData;
        for (let dt of Object.keys(item)) {
          if (fieldData.includes("{$" + dt + "}")) {
            fieldData = fieldData.replaceAll("{$" + dt + "}", item[dt]);
          }
        }
        option[fld.optionField] = fieldData;
        prevValue = fieldData;
      }
      option.item = item;
    } else if (props.valueField) {
      option.label = item[props.labelField];
      option.value = item[props.valueField];
      option.item = item;
    } else {
      option.value = item;
      option.label = item;
    }
    options.push(option);
  });

  const validateMandatory = () => {
    const isEmpty = props.isMulti
      ? (!props.value || !Array.isArray(props.value) || props.value.length === 0)
      : (!props.value || props.value === "");
    if (isEmpty) {
      if (!props.mandatoryFields?.includes(props.name)) {
        props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
      }
      return "Please provide valid " + props.fieldName;
    } else {
      let mandatoryFieldsTemp = props.mandatoryFields;
      if (mandatoryFieldsTemp?.length > 0) {
        const index = mandatoryFieldsTemp?.indexOf(props.name);
        if (index > -1) {
          mandatoryFieldsTemp.splice(index, 1);
        }
        props.setMandatoryFields && props.setMandatoryFields(mandatoryFieldsTemp);
      }
      return "";
    }
  };

  const validateSpecialCharacters = (value) => {
    return "";
  };

  const allValidations = () => {
    let errorMsg = "";
    if (props?.required && !props?.readOnly) {
      errorMsg = validateMandatory();
    }
    if (errorMsg) {
      props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
      return;
    } else {
      props.setError((prev) => ({ ...prev, [props.name]: "" }));
    }
    if (props.value && props.value !== "") {
      const validations = [
        { condition: props.hasOwnProperty("isAlphanumeric"), regex: alphanumericWithSpaceRegex, msg: " must be alphanumeric" },
        { condition: props.hasOwnProperty("isAlphanumericWithoutSpace"), regex: alphanumericWithoutSpaceRegex, msg: " must be alphanumeric without space" },
        { condition: props.hasOwnProperty("isAplhaNumericWithSpecialChars"), regex: AplhaNumericWithSpecialChars, msg: " must be alphanumeric with special characters" },
        { condition: props.hasOwnProperty("isAlphaNumericSpace"), regex: AlphaNumericSpace, msg: " must be alphanumeric with space" },
        { condition: props.hasOwnProperty("isAlphanNumeric"), regex: AlphanNumeric, msg: " must be alphanumeric" },
      ];

      for (const { condition, regex, msg } of validations) {
        if (condition && !regex.test(props.value)) {
          props.setError(props.fieldName + msg);
          return;
        }
      }
      errorMsg = validateSpecialCharacters(props.value);
      if (errorMsg) {
        props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
      } else {
        props.setError((prev) => ({ ...prev, [props.name]: "" }));
      }
      if (props.customValidation) {
        errorMsg = props.customValidation(props.value, props.name);
      }
    }
    if (props.setError) props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
  };

  useEffect(() => {
    if (props.required && !props.value && !props.mandatoryFields?.includes(props.name)) {
      props.setMandatoryFields && props.setMandatoryFields((prev) => 
        prev.includes(props.name) ? prev : [...prev, props.name]
      );
    } else if (props.required && props.value && props.value !== "") {
      props.setMandatoryFields && props.setMandatoryFields((prev) => prev.filter((f) => f !== props.name));
    }
    return () => {
      if (props.required) {
        props.setMandatoryFields && props.setMandatoryFields((prev) => prev.filter((f) => f !== props.name));
      }
    };
  }, []);

  useEffect(() => {
    if (props.submit) {
      props.setFieldCount((prev) => ([...prev, props.name]));
      allValidations();
    }
  }, [props.submit]);

  const handleChange = (opt) => {
    if (!props.readOnly) {
      props.onChange(opt);
    }
  };

  const hasValue = props.isMulti
    ? (Array.isArray(props.value) && props.value.length > 0)
    : (props?.value && props?.value !== "");

  return (
    <Form.Group ref={containerRef} className={`g-input-select ${props.className || ""} ${props.readOnly ? "read-only" : ""} ${props.disabled ? "disabled" : ""} ${expanded ? "multi-expanded" : ""} ${props.isMulti && !focus ? "multi-unfocused" : ""}`}>
      <Select
        ref={selectRef}
        menuPosition="fixed"
        classNamePrefix="select"
        className={` ${props.error && props.error[props.name] ? "text-field-with-error" : ""}`}
        options={options}
        blurInputOnSelect={false}
        closeMenuOnSelect={true}
        onBlur={() => { setExpanded(false); setFocus(false); allValidations(); }}
        value={props.isMulti ? selectedOption : (props.value ? { label: selectedOption?.label, value: props?.value } : {})}
        isMulti={props.isMulti || false}
        {...(props.isMulti && {
          components: {
            ValueContainer: ({ children, ...vcProps }) => {
              const selected = vcProps.getValue();
              const childArray = React.Children.toArray(children);
              const input = childArray.slice(-1);
              const tags = childArray.slice(0, -1);
              if (expanded) {
                return (
                  <components.ValueContainer {...vcProps}>
                    {tags}
                    {input}
                  </components.ValueContainer>
                );
              }
              const maxVisible = 2;
              const overflow = selected.length - maxVisible;
              const hiddenValues = selected.slice(maxVisible).map(s => s.label).join(", ");
              return (
                <components.ValueContainer {...vcProps}>
                  {tags.slice(0, maxVisible)}
                  {overflow > 0 && (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip className="custom-tooltip">{hiddenValues}</Tooltip>}
                    >
                      <span
                        className="select__multi-overflow"
                        onClick={(e) => { e.stopPropagation(); e.preventDefault(); if (!props.disabled && !props.readOnly) setExpanded(true); }}
                      >
                        +{overflow}
                      </span>
                    </OverlayTrigger>
                  )}
                  {input}
                </components.ValueContainer>
              );
            }
          }
        })}
        isDisabled={props.disabled || props.readOnly}
        placeholder=""
        id={props.id}
        style={props.style}
        required={props.required}
        inputId={props.name}
        onFocus={() => { setFocus(true); }}
        onChange={(opt) => {
          let obj = props.isMulti
            ? { target: { name: props.name, value: opt ? opt.map(o => o.value) : [] } }
            : { target: { name: props.name, value: opt.value, item: opt.item } };
          handleChange(obj);
          if (props.isMulti && opt && opt.length > 0) {
            props.setError && props.setError((prev) => ({ ...prev, [props.name]: "" }));
          }
          if (!props.isMulti) {
            setFocus(false);
          }
        }}
      />
      <Form.Label className={`${(focus || hasValue) ? "active" : ""} ${props.error && props.error[props.name] ? "text-label-with-error" : ""}`} htmlFor={props.name}>
        {props.label}
        {(props.optional === true) && <span className="optional"> (optional)</span>}
      </Form.Label>

      {focus && !props.error && <div className="hint">{props.hint}</div>}

      {props.error && <div className="error">{props.error}</div>}
    </Form.Group>
  );
}
